<mat-dialog-content
  class="m-0 p-0 mat-typography flex flex-row overflow-hidden"
  *transloco="let fieldTranslation; read: 'field-types'"
>
  <div class="w-2/6 bg-white flex flex-col overflow-hidden">
    <div class="p-4 flex flex-col space-y-1">
      <div class="text-xl">{{ fieldTranslation(field.type.id) }}</div>
      <div class="text-secondary">{{ fieldTranslation(field.type.id + "-description") }}</div>
    </div>
    <div class="pl-6 pr-6 pb-6 w-full overflow-y-auto">
      <!-- Form -->
      <form
        [formGroup]="form"
        class="flex flex-col space-y-4"
      >
        <mat-form-field class="fuse-mat-no-subscript w-full">
          <mat-label>Título</mat-label>
          <input
            [formControlName]="'label'"
            autocomplete="off"
            matInput
            cdkFocusInitial
          />
        </mat-form-field>

        <ng-template #fieldEditorContent></ng-template>

        <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full">
          <mat-label>{{ fieldTranslation("Hint") }}</mat-label>
          <textarea
            matInput
            [placeholder]="fieldTranslation('Hint')"
            [formControlName]="'description'"
            cdkTextareaAutosize
            [cdkAutosizeMinRows]="1"
            [cdkAutosizeMaxRows]="2"
          ></textarea>
        </mat-form-field>

        <div class="flex items-center justify-between">
          <div
            class="flex-auto leading-6 cursor-pointer"
            (click)="mention.toggle()"
          >
            {{ fieldTranslation("Required") }}
          </div>
          <mat-slide-toggle
            class="ml-2"
            color="primary"
            [formControlName]="'required'"
            #mention
          >
          </mat-slide-toggle>
        </div>
      </form>
    </div>

    <!-- Divider -->
    <div class="border-t"></div>

    <div class="p-4 w-full flex flex-row items-center space-x-3 justify-end">
      <button
        mat-stroked-button
        mat-dialog-close
      >
        Cancelar
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="save()"
        [disabled]="!form.valid || !fieldValid"
      >
        Salvar
      </button>
    </div>
  </div>

  <div class="w-4/6 flex bg-gray-50">
    <div class="w-full flex flex-col items-center rounded">
      <div class="h-12"></div>
      <div class="w-160 h-full p-8 space-y-6 flex flex-col bg-white items-center rounded overflow-hidden">
        <span>Vista prévia</span>
        <div class="overflow-y-auto">
          <control-preview
            [field]="editableField"
            [editable]="false"
          ></control-preview>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
